<svg width="48"
     height="49"
     viewBox="0 0 48 49"
     fill="none"
     xmlns="http://www.w3.org/2000/svg"
     aria-hidden="true"
     focusable="false">
      <path fill-rule="evenodd"
            clip-rule="evenodd"
            d="M24 12.5C17.376 12.5 12 17.876 12 24.5C12 31.124 17.376 36.5 24 36.5C30.624 36.5 36 31.124 36 24.5C36 17.876 30.624 12.5 24 12.5ZM31.632 30.296C29.916 28.208 25.752 27.5 24 27.5C22.248 27.5 18.084 28.208 16.368 30.296C15.144 28.688 14.4 26.684 14.4 24.5C14.4 19.208 18.708 14.9 24 14.9C29.292 14.9 33.6 19.208 33.6 24.5C33.6 26.684 32.856 28.688 31.632 30.296ZM19.8 21.5C19.8 19.172 21.672 17.3 24 17.3C26.328 17.3 28.2 19.172 28.2 21.5C28.2 23.828 26.328 25.7 24 25.7C21.672 25.7 19.8 23.828 19.8 21.5Z"
            fill="currentColor" />
</svg>